import React from 'react';
import BaseProtocol from '../Application/BaseProtocol';
import { PT_PROTOCOL_ITEMS } from './ptProtocolConstants';

const PtProtocol = ({ targetUserId, onClose }) => {
    return (
        <BaseProtocol
            role="PT"
            title="PT JOB DESCRIPTION"
            items={PT_PROTOCOL_ITEMS}
            apiEndpoint="/job-descriptions"
            fetchEndpoint="/job-descriptions"
            defaultValues={{
                userId: targetUserId
            }}
            onClose={onClose}
        />
    );
};

export default PtProtocol;
